package com.trevorwiebe.timesheet.admin.employeeHours.presentation

import com.trevorwiebe.timesheet.admin.employeeHours.domain.EmployeeHoursSummary
import com.trevorwiebe.timesheet.core.domain.model.Rate

data class EmployeeHoursState(
    val isLoading: Boolean = true,
    // True during a background re-load when data is already on screen (returning to the screen).
    // Drives a thin progress bar so the user knows their changes are being picked up.
    val isRefreshing: Boolean = false,
    val summaries: List<EmployeeHoursSummary> = emptyList(),
    // Org rates, used by the CSV export to resolve each rate's stored payroll code.
    val rates: List<Rate> = emptyList(),
    val error: String? = null,
    // True when every previous-period timesheet has been confirmed by its employee, so the admin
    // may export it to payroll. Drives the export button's behavior on both platforms.
    val canExportPrevious: Boolean = false,
)
